import { Inject, Injectable } from '@angular/core';
import { RestApiService } from '@services/rest-api/rest-api.service';
import { ContractInfo, CartShortInfo } from '@shared/interfaces/ordering-carts/ordering-carts.interface';
import { Observable } from 'rxjs';
import { Cart } from '@shared/interfaces/ordering-carts/cart';
import { API_PATH } from '@shared/tokens';

@Injectable({
  providedIn: 'root',
})
export class OrderingCartsService {
  constructor(
    @Inject(API_PATH) private readonly apiPath: string,
    private http: RestApiService,
  ) {}

  getCurrentShortInfo(form: ContractInfo): Observable<CartShortInfo> {
    return this.http.post<CartShortInfo, ContractInfo>(this.apiPath + '/ordering/carts/current/get-short-info', form);
  }

  getCurrentCart(form: ContractInfo): Observable<Cart> {
    return this.http.post<Cart, ContractInfo>(this.apiPath + '/ordering/carts/current/get', form);
  }
}
